import React, { useState } from "react";
import TicketSummary from "./ClientSummary";
import ClientTicketList from "./ClientTicketList";
const ClientDashboard = () => {
  const [searchParams, setSearchParams] = useState({});

  const handleSearch = (params) => {
    setSearchParams(params);
  };
  const [inputValue, setInputValue] = useState("");

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      setSearchParams({ searchText: inputValue });
    }
  };

  return (
    <>
      <div>
        <h1 className="text-2xl font-bold text-gray-700 mb-6 text-center">Client Dashboard</h1>

        {/* Centered Search Box */}
        <div className="flex justify-center mb-6">
          <input
            value={inputValue}
            onChange={(e) => setInputValue(e.target.value)}
            onKeyDown={handleKeyDown}
            autoFocus
            type="text"
            placeholder="Search clients..."
            className="w-[80vh] px-4 py-2 border border-gray-300 rounded-xl shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
          />
        </div>
        <section className="bg-white shadow-md p-4 rounded-lg mb-4">
          <h2 className="text-gray-400 text-lg text-center font-semibold mb-4">Client Summary</h2>
          <hr />
          <TicketSummary searchParams={searchParams} />
        </section>
        <section className="bg-white shadow-md p-6 rounded-lg mb-6">
          <h2 className="text-gray-700 text-lg font-semibold mb-4">Ticket List</h2>
          <div className="overflow-x-auto">
            <ClientTicketList searchParams={searchParams} />
          </div>
        </section>
      </div>
    </>
  );
};

export default ClientDashboard;